const CONFIG = {
  BASE_URL: 'https://restaurant-api.dicoding.dev',
  IMAGE_URL: 'https://restaurant-api.dicoding.dev/images/medium/',
  DATABASE_NAME: 'foodies-database',
  DATABASE_VERSION: 1,
  OBJECT_STORE_NAME: 'restaurant',
};

export default CONFIG;
